export const ru = {
    "common.empty": "Пусто",
    "common.in": "в",
    "common.actions.close": "Закрыть",
    "common.actions.delete": "Удалить",
    "common.actions.cancel": "Отменить",
    "common.actions.select": "Выбрать",
    "common.actions.confirm-deletion": "Подтвердить удаление",
    "common.actions.try_again": "Повторить попытку",
    "common.actions.go_to": "Перейти",
    "common.actions.step_back": "Назад",
    "common.actions.refresh": "Обновить",

    "wallet.auth.title": "Создать аккаунт электронного кошелька",
    "wallet.auth.register": "Зарегистрироваться",
    "wallet.auth.login": "Войти",
    "wallet.auth.already_have": "У вас есть счет?",

    "auth.register.title": "Регистрация",
    "auth.register.first_name": "Ваше имя",
    "auth.register.last_name": "Ваша фамилия",
    "auth.register.email": "Email",
    "auth.register.address": "Адрес",
    "auth.register.city": "Город",
    "auth.register.country": "Страна",
    "auth.register.zip_code": "Почтовый индекс",
    "auth.register.address_section": "Информация об адресе",
    "auth.register.continue_btn": "Продолжить",    
    "auth.register.enter_help": "Вход для зарегистрированных пользователей.",
    "auth.register.enter_code_help": "Введите код из сообщения",
    "auth.register.enter_code_descr": "Введите 4-значный код, который мы выслали по номеру",
    "auth.register.send_again_btn": "Отправить еще раз",
    "auth.register.set_pin.help": "Установите пин-код",
    "auth.register.set_pin.descr": "Придумайте 4-значный пин-код, который вы будете использовать при подтверждении транзакций",
    "auth.register.set_pin.continue": "Продолжить",        
    
    "wallet.auth.login.register_link": "Регистрация",
    "wallet.auth.login.login": "Вход в личный кабинет",
    "wallet.auth.login.sms_help": "Вы получите SMS-сообщение с кодом подтверждения для входа в личный кабинет. ",
    "wallet.auth.login.new_help": "Регистрация для новых пользователей. ",
    "wallet.auth.login.send_code": "Отправить код",
    "wallet.auth.login.enter_code": "Введите код из сообщения",
    "wallet.auth.login.enter_code_descr": "Введите 4-значный код, который мы выслали по номеру",
    "wallet.auth.login.enter_btn": "Войти",
    "wallet.auth.login.sms_repeat": "Отправить еще раз",    
    "wallet.auth.change_number": "Изменить номер", 

    "phone_input.phone": "Номер телефона",    
    "phone_input.phone.default_country.name": "Russia",
    "phone_input.phone.default_country.code": "+7",    
    "phone_input.phone.default_country.iso": "RU",        
    "phone_input.phone.default_country.flag": "https://cdn.kcak11.com/CountryFlags/countries/ru.svg",        
    "phone_input.phone.default_country.mask": "(###)###-##-##",        

    "menu.home": "Главная",    
    "menu.wallet": "Кошелек",
    "menu.payment": "Оплата",
    "menu.history": "История",
    "menu.cards": "Карты",
    "menu.settings": "Аккаунт",

    "notifications.title": "Уведомления",
    "notifications.close_btn": "Закрыть",

    "qr_payment.title": "Платите с помощью QR-code",
    "qr_payment.description": "Теперь вы можете переводить средства просто наведя камеру на QR-code",

    "qr_payment.not_avaliable.title": "Оплата QR-кодом временно недоступна,",
    "qr_payment.not_avaliable.subtitle": "приносим извинения за доставленные неудобства.",
    "qr_payment.your_qr": "Ваш QR-code",
    "qr_payment.scan_qr": "Сканировать",

    "payment.topup_btn": "Пополнить",
    "payment.exchange_btn": "Обмен",
    "payment.withdrawal_btn": "Вывести",
    "payment.topup.not_avaliable": "Вывод средств не доступен, пожалуйста, пройдите идентификацию.",
    "payment.withdrawal.not_avaliable": "Пополнение кошелька не доступно, пожалуйста, пройдите идентификацию.",
    "payment.send_btn": "Отправить",
    "payment.qr_file_upload": "Перетащите или выберите файл QR-code",
    "payment.qr_file_upload_extensions": "Допустимые форматы: png, jpg",

    "wallet_save.send_btn": "Отправить",

    "transactions.title": "Транзакции",
    "transactions.last.title": "Последние транзакции",
    "transactions.list.operation": "Операция",
    "transactions.list.withdrawal": "Вывод",
    "transactions.list.topup": "Пополнение",
    "transactions.list.empty_descr": "Совершите первый платеж и в этом месте появится список Ваших транзакций",
    "transactions.list.status.complete": "Завершена",
    "transactions.list.status.failed": "Ошибка",
    "transactions.list.status.pending": "В процессе",

    "account.create_btn": "+ Добавить счет",
    "account.create_new_btn": "+ Добавить новый счет",

    "history.title": "История",
    "history.category.default": "default",

    "profile.title": "Данные об аккаунте",
    "profile.email": "E-mail:",
    "profile.phone": "Телефон",
    "profile.register_date": "Дата регистрации",
    "profile.logout": "Выйти из аккаунта",
    

    "profile.identification.title": "Уровень идентификации",
    "profile.identification.level.title": "Текущий уровень",
    "profile.identification.upgrade.status": "Статус повышения",    
    "profile.identification.upgrade_btn": "Повысить",
    "profile.identification.refresh_status_btn": "Обновить статус",
    "profile.identification.retry_upgrade_btn": "Повторить идентификацию",
    "profile.identification.profile_type": "Личный профиль",

    "profile.qr.title": "Это ваш  QR-code",        
    "profile.qr.share": "Поделитесь кодом, чтобы получать оплату",        
    "profile.qr.download": "Скачать QR-code",        
    
    "select_currency.text": 'Выберите валюту',

    "policy.title": "Юридическая информация",

    "exchange.title": 'Обмен валют',
    "exchange.from": 'из',
    "exchange.to": 'в',
    "exchange.current_balance": 'На счету:',
    "exchange.submit_btn": 'Обменять',
    "exchange.no_rate": 'Курс не доступен',
    "exchange.not_available": 'Функция обмена недоступна для вашего аккаунта',
    "exchange.rate_is_changed_modal.title": 'Курс изменился',
    "exchange.rate_is_changed_modal.info": 'Во время перевода средств курс был изменен',
    "exchange.status_modal.title.pending": 'Ожидание обмена',
    "exchange.status_modal.title.success": 'Обмен прошел успешно!',
    "exchange.status_modal.title.error": 'Не удалось обменять',
    "exchange.status_modal.dont_close": 'Не закрывайте страницу',
    "exchange.status_modal.try_again_later": 'Повторите попытку позже',
    "exchange.status_modal.info.summary": 'Сумма',
    "exchange.status_modal.info.rate": 'Курс обмена',
    "exchange.status_modal.info.date": 'Дата транзакции',

    "wallet_topup.modal.title": "Пополнение счета",
    "wallet_topup.select_account": "Выберите счет",
    "wallet_topup.amount": "Сумма",
    "wallet_topup.top_up": "Пополнить",
    "wallet_topup.accept_the": "Я принимаю",
    "wallet_topup.terms_of_use": "Условия использования",
    "wallet_topup.success": "Успех",    
    "wallet_topup.error": "Пополнение счёта временно недоступно. Повторите попытку позже.",
    "wallet_topup.error_empty_amount": "Поле «Сумма» должно быть заполнено",
    "wallet_topup.error_exceed_limit": "Превышен доступный лимит в 15 000 ₽. Чтобы продолжить, необходимо пройти верификацию",
    "wallet_topup.card-error": "Пополнение счёта картой временно недоступно. Повторите попытку позже.",
    "wallet_topup.methods.cbp": "СБП",
    "wallet_topup.methods.cash": "Пополнение наличными",
    "wallet_topup.methods.bank_card": "Банковская карта",

    "wallet_withdrawal.select_account": "Выберите счет",
    "wallet_withdrawal.amount": "Сумма",
    "wallet_withdrawal.card": "Карта",
    "wallet_withdrawal.to-card": "Вывод на карту",
    "wallet_withdrawal.cash": "Снятие наличных",
    "wallet_withdrawal.success_message": "Заявка на вывод средств успешно создана!",
    "wallet_withdrawal.withdrawal_btn": "Вывести",
    "wallet_withdrawal.usdc_etc_address": "Адрес вывода",

    "pay_modal.enter_pin": "Введите пин-код",
    "pay_modal.enter_pin_description": "Для подтверждения перевода введите ваш пин-код",
    "pay_modal.waiting": "Ожидание",
    "pay_modal.waiting_description": "Не закрывайте страницу",
    "pay_modal.try_again": "Повторите попытку позже",

    "balance_zero_state.title": "Пополните счет",
    "balance_zero_state.info": "Создайте свой первый валютный счет в кошельке и откройте новые возможности",
    "balance_zero_state.action": "Пополните счет",
    "kyc_zero_state.title": "Пройти KYC",
    "kyc_zero_state.info": "Для доступа к функциям сервиса необходима верификация личности",
    "kyc_zero_state.action": "Пройти KYC",
    "kyc_modal.title": "Данный функционал недоступен",
    "kyc_modal.info": "Для доступа ко всем функциям приложения пройдите верификацию личности",
    "kyc_modal.action": "Пройти KYC",

    "cards_empty_list.title": "Нет созданных карт",
    "cards_empty_list.info_text": "Создайте свою первую виртуальную карту ",
    "cards_empty_list.action_label": "Создайте новую карту",

    "cards_list.add_new_card": "Добавить новую карту",

    "card_snippet.balance": "Баланс",
    "card_snippet.holder": "Владелец",
    "card_snippet.creating": "Создание карты",
    "card_snippet.verify_processed": "Процесс верификации...",
    "card_snippet.verify_finished": "Верификация одобрена!",

    "card_page.action.replenishment": "Пополнить",
    "card_page.action.freeze": "Заморозить",
    "card_page.action.freeze.modal.title": "Заморозить карту",
    "card_page.action.freeze.modal.info": "При заморозке карты, все транзакции с ней будут недоступны. Разморозить карту можно в любой момент",
    "card_page.action.unfreeze": "Разморозить",
    "card_page.action.unfreeze.modal.title": "Разморозить крату",
    "card_page.action.unfreeze.modal.info": "После разморозки карты, все транзакции снова буду доступны",
    "card_page.action.show": "Показать",
    "card_page.action.hide": "Скрыть",
    "card_page.action.confirm": "Подтвердить",
    "card_page.action.remove": "Подтвердить удаление",
    "card_page.action.remove.modal.title": "Удаление карты",
    "card_page.action.remove.modal.info": "При удалении карты средства будут безвозвратно утеряны и не подлежат возврату",
    "card_page.card-details.title": "Реквизиты карты",
    "card_page.card-info.title": "Информация о карте",
    "card_page.card-info.status.active": "Активна",
    "card_page.card-info.status.frozen": "Заморожена",
    "card_page.card-info.card_number": "Номер карты",
    "card_page.card-info.expired": "Срок истечения",
    "card_page.card-info.id": "Идентификатор",
    "card_page.rules.min_deposit": "Мин. депозит",
    "card_page.rules.max_deposit": "Макс. депозит",

    "card_page.replenishment.title": "Пополнение карты",
    "card_page.replenishment.write_off_account": "Со счета кошелька",
    "card_page.replenishment.select_account": "Выберите счет списания",
    "card_page.replenishment.to_card": "На счет карты",
    "card_page.replenishment.conversion_rate": "Курс конвертации",
    "card_page.replenishment.fee": "Комиссия за перевод",
    "card_page.replenishment.action.replenishment_on": "Пополнить на",
    "card_page.replenishment.action.not_enough_balance": "Сумма превышает доступный баланс",
    "card_page.replenishment.action.exceeds_the_limit": "Выходит за лимиты пополнения",
    "card_page.replenishment.amount_from": "Сумма от",
    "card_page.replenishment.to": "до",
    "card_page.replenishment.statuses.processing.title": "Ожидание пополнения",
    "card_page.replenishment.statuses.processing.dont_close": "Не закрывайте страницу",
    "card_page.replenishment.statuses.success.title": "Пополнение прошло успешно!",
    "card_page.replenishment.statuses.failed.title": "Пополнение не прошло",
    "card_page.replenishment.statuses.failed.try_again": "Повторите попытку позже",
    "card_page.replenishment.statuses.transaction_info.amount": "Сумма",
    "card_page.replenishment.statuses.transaction_info.rate": "Курс обмена",
    "card_page.replenishment.statuses.transaction_info.card": "Карта пополнения",
    "card_page.replenishment.statuses.transaction_info.date": "Дата транзакции",
    "card_page.replenishment.statuses.transaction_info.id": "ID транзакции",

    "create_card_page.action_btn.title": "Создание карты",
    "create_card_page.selects.empty": "Не выбрано",
    "create_card_page.selects.choose_currency": "Выберите валюту",
    "create_card_page.selects.selected_currency": "Выбранная валюта",
    "create_card_page.info.title": "Детали в случае успешной активации",
    "create_card_page.info.type": "Тип карты",
    "create_card_page.info.currency": "Валюта",
    "create_card_page.info.price": "Плата за активацию",
    "create_card_page.info.min_deposit": "Мин депозит",
    "create_card_page.info.max_deposit": "Макс депозит",

    "create_card_page.kyc.occupation": "Род занятий",
    "create_card_page.kyc.occupations.employed": "Работает по найму",
    "create_card_page.kyc.occupations.self_employed": "Самозанятый",
    "create_card_page.kyc.occupations.business_owner": "Владелец бизнеса",
    "create_card_page.kyc.occupations.student": "Студент",
    "create_card_page.kyc.occupations.unemployed": "Безработный",
    "create_card_page.kyc.occupations.retired": "Пенсионер",
    "create_card_page.kyc.occupations.freelancer": "Фрилансер",
    "create_card_page.kyc.occupations.government_employee": "Государственный служащий",
    "create_card_page.kyc.occupations.homemaker": "Домохозяйка",
    "create_card_page.kyc.occupations.investor": "Инвестор",
    "create_card_page.kyc.salary": "Годовая зарплата",
    "create_card_page.kyc.purpose": "Цель счета",
    "create_card_page.kyc.purposes.investments": "Инвестиции",
    "create_card_page.kyc.purposes.introduction": "Ознакомление",
    "create_card_page.kyc.purposes.for_work": "Для работы",
    "create_card_page.kyc.purposes.for_business": "Для бизнеса",
    "create_card_page.kyc.purposes.for_storing": "Для хранения денежных средств",
    "create_card_page.kyc.purposes.personal_purposes": "Личные цели",
    "create_card_page.kyc.volume": "Ожидаемый объем в мес.",
    "create_card_page.kyc.email": "Email",
    "create_card_page.kyc.phone": "Номер телефона",

    "create_card_page.confirmation.title": "Введите код из почты",
    "create_card_page.confirmation.info": "Введите 4-значный код, который мы выслали по адерсу",

    "create_card_page.action_btn.accept": "Принять",
    "create_card_page.action_btn.send": "Отправить",
    "create_card_page.action_btn.next": "Далее",
    "create_card_page.action_btn.send_code": "Отправить код ",
    "create_card_page.action_btn.resend_code": "Отправить код еще раз",
    "create_card_page.errors.wrong_code": "Неверный код",

    "create_card_banner.title": "Виртуальная карта",
    "create_card_banner.subtitle": "Создайте свою первую виртуальную карту",
    "create_card_banner.action": "Создать карту",

    "verification_card_page.statuses.process.title": "Идет процесс верификации",
    "verification_card_page.statuses.process.info": "Пожалуйста, ожидайте, идет проверка данных",
    "verification_card_page.statuses.failed.title": "Верификация не пройдена",
    "verification_card_page.statuses.failed.info": "Пожалуйста, просмотрите и обновите свою информацию, чтобы продолжить выпуск виратуальной карты",
    "verification_card_page.statuses.declined.title": "Заявка отклонена",
    "verification_card_page.statuses.declined.info": "В настоящее время мы не можем выпустить карту для вашего счета",
    "verification_card_page.statuses.approved.title": "Верификация одобрена!",
    "verification_card_page.statuses.approved.info": "Чтобы выпустить виртуальную карту, подтвердите оплату",
    "verification_card_page.statuses.approved.conditions.card_issuance": "Выпуск карты",
    "verification_card_page.statuses.approved.conditions.min_deposit": "Выпуск карты",
    "verification_card_page.statuses.approved.conditions.total_amount": "Общая сумма",
    "verification_card_page.statuses.approved.conditions.warning": "Сумма будет списана с вашего кошелька",
    "verification_card_page.statuses.created.title": "Карта создана успешно",
    "verification_card_page.statuses.created.info": "Ваша виртуальная карта выпущена и готова к использованию",
    "verification_card_page.statuses.low_balance.title": "Недостаточно средств",
    "verification_card_page.statuses.low_balance.info": "Пожалуйста, пополните счет кошелька и повторите попытку.",

    "verification_card_page.actions.close": "Закрыть",
    "verification_card_page.actions.refresh": "Обновить информацию",
    "verification_card_page.actions.confirm": "Подтвердить и оплатить",
    "verification_card_page.actions.to_card": "Перейти в карту",
    "verification_card_page.actions.to_up": "Пополнить кошелек",

    "actives.common": "Общие активы"
}
